/** @format */

export function ShipmentListItemSkeleton() {
  return (
    <div className="bg-white border border-[#E4E7EC] rounded-[12px] p-4 animate-pulse" aria-hidden>
      <div className="flex items-center justify-between mb-2 gap-2">
        <div className="h-3 bg-[#E4E7EC] rounded w-24" />
        <div className="h-5 bg-[#F2F4F7] rounded-full w-16" />
      </div>
      <div className="h-4 bg-[#E4E7EC] rounded w-3/4 mb-3" />
      <div className="flex justify-between gap-2">
        <div className="flex-1 space-y-2">
          <div className="h-3 bg-[#F2F4F7] rounded w-full" />
          <div className="h-4 bg-[#E4E7EC] rounded w-20" />
        </div>
        <div className="flex-1 space-y-2 text-right">
          <div className="h-3 bg-[#F2F4F7] rounded w-full ml-auto" />
          <div className="h-4 bg-[#E4E7EC] rounded w-20 ml-auto" />
        </div>
      </div>
    </div>
  );
}

export function ShipmentListLoadingSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: rows }).map((_, i) => (
        <ShipmentListItemSkeleton key={i} />
      ))}
    </div>
  );
}
